import { ActionProps } from "../store";
export function reducer(state: any, action: ActionProps) {
  switch (action.type) {
    default:
      return state;
  }
}
